import { ComponentProps } from "react"
import { twMerge } from "tailwind-merge"

type textInputProps = ComponentProps<'input'>

export function TextInput(props: textInputProps) {
    return (
        <input {...props}
            className={twMerge(`
                py-2 px-3 outline-hidden appearance-none 
                rounded-sm shadow border border-dark_secondary dark:border-light_secondary
                dark:bg-silver-500 focus:ring-ochre_accent focus:border-ochre_accent`,
                props.className)} />
    )
}